import React from "react";
import { useUserTheme } from "src/shared/hooks/useUserTheme";

interface ViewOrderButtonProps {
  orderId: string;
  isLoading: boolean;
  onViewOrder: (orderId: string) => void;
}

const ViewOrderButton: React.FC<ViewOrderButtonProps> = ({ orderId, isLoading, onViewOrder }) => {
  const { bgClass, fontClass} = useUserTheme();
  return (
    <button className={`view-btn ${bgClass} ${fontClass}`} onClick={() => onViewOrder(orderId)} disabled={isLoading}>
      {isLoading ? "Loading..." : "View"}
    </button>
  );
};

export default ViewOrderButton;
